<template>
  <div class="login">
    <div class="login-center">
      <div class="login-title">供应商登录入口</div>
      <el-form
        ref="form"
        class="login-form"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="userName">
          <el-input
            v-model="form.userName"
            placeholder="请输入邮箱"
          >
            <img slot="prefix" class="icon-user" src="@/assets/images/icon-user.png">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            type="password"
            @keyup.enter.native="login"
          >
            <img slot="prefix" class="icon-lock" src="@/assets/images/icon-lock.png">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="login-action">
        <el-checkbox v-model="remember" class="login-remember-pwd">保存密码</el-checkbox>
        <div class="login-action-right">
          <router-link tag="span" to="register">立即注册</router-link>
          <router-link tag="span" to="forgetPassword">忘记密码?</router-link>
        </div>
      </div>
      <el-button class="login-button" type="primary" :loading="loading" @click="login">登录</el-button>
      <a class="btn-admin-login" href="http://www.istopcc.com/bid-admin" target="__blank">甲方登录入口</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { login } from '@/api'

const LOCALSTORAGE_ACCOUNT_KEY = 'account'

export default {
  data() {
    return {
      form: {
        userName: '',
        password: ''
      },

      formRules: {
        userName: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      },

      remember: false,
      loading: false
    }
  },

  created() {
    this.getAccountInfo()
  },

  methods: {
    ...mapActions([
      'setUserInfo'
    ]),

    /*
         * 登录
        */
    login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { userName, password } = this.form

          this.loading = true

          try {
            const res = await login({
              userName: userName,
              pass: password
            })

            const { userInfo, token } = res.data

            // 登录成功后，保存账号密码
            this.remember ? this.saveAccountInfo() : this.removeAccountInfo()

            this.setUserInfo(userInfo)
            this.$cookie.set('web-token', token)

            const { redirect = '/' } = this.$route.query
            this.$router.replace({
              path: redirect
            })
          } catch (error) {
            const { message, code, data: userInfo } = error

            if (code === 402) {
              // 保持需要修改的用户信息
              localStorage.setItem('edit_userInfo', JSON.stringify(Object.assign(userInfo, { password })))

              this.$router.push({
                name: 'register',
                query: {
                  isEdit: 1
                }
              })
            }

            this.$message.error(message)
          }

          this.loading = false
        }
      })
    },

    /*
         * 将账号密码存入localStorage
        */
    saveAccountInfo() {
      localStorage.setItem(LOCALSTORAGE_ACCOUNT_KEY, JSON.stringify(this.form))
    },

    /*
         * 获取已存入localStorage的账号密码
        */
    getAccountInfo() {
      const account = localStorage.getItem(LOCALSTORAGE_ACCOUNT_KEY)

      if (account) {
        this.form = JSON.parse(account)
        this.remember = true
      }
    },

    /*
         * 移除已存入localStorage的账号密码
        */
    removeAccountInfo() {
      localStorage.removeItem(LOCALSTORAGE_ACCOUNT_KEY)
    }
  }
}
</script>

<style lang='scss' scoped>
.login {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 100%;
    background-color: #fff;
    background-image: url("~@/assets/images/login-bg.png");
    background-repeat: no-repeat;
    background-size: 100% calc(100% - var(--footer-height));
    background-position: top left;
    padding: 0 18% var(--footer-height) 0;
    .login-center {
        display: flex;
        flex-direction: column;
        width: 442px;
        font-size: 16px;
        border-radius: 10px;
        padding: 60px 55px 45px;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 10px 17px 50px 0 rgba(34, 20, 23, 0.35);
        .login-title {
            font-size: 23px;
            color: #050505;
            text-align: center;
        }
        /deep/ .login-form {
            margin: 53px 0 0;
            .el-input {
                font-size: 16px;
                .el-input__inner {
                    height: 53px;
                    padding-left: 58px;
                    border-radius: 27px;
                    border: 0;
                    background-color: #f5f5f5;
                }
                .el-input__prefix {
                    left: 30px;
                    display: flex;
                    align-items: center;
                    transform: translateX(-50%);
                    color: #acacac;
                    img {
                      width: 26px;
                    }
                }
            }
        }
        .login-action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 15px;
            /deep/ .login-remember-pwd {
              display: inline-flex;
              align-items: center;
              .el-checkbox__inner {
                  width: 18px;
                  height: 18px;
                  border-color: #c2c2c2;
                  border-radius: 6px;
                  vertical-align: top;
                  &::after {
                      width: 4px;
                      height: 10px;
                      left: 5px;
                      top: 1px;
                  }
              }
              .el-checkbox__label {
                  line-height: 18px;
                  color: #666;
                  vertical-align: top;
              }
            }
            .login-action-right {
                display: flex;
                align-items: center;
                color: #417EF7;
                > span {
                    cursor: pointer;
                    margin: 0 0 0 28px;
                }
            }
        }
        .login-button {
            width: 100%;
            height: 54px;
            font-size: 23px;
            line-height: 52px;
            padding: 0;
            border-radius: 30px;
            margin: 35px 0 0;
        }
        .btn-admin-login {
          display: table;
          font-size: 18px;
          color: #417EF7;
          margin: 35px auto 0;
        }
    }
}
</style>
